import Vue from 'vue';
import VueI18n from 'vue-i18n';
import vuetifyEn from 'vuetify/es5/locale/en';
import vuetifyEs from './es/vuetify';
import messageEn from './en/message';
import messageEs from './es/message';

Vue.use(VueI18n);

const messages = {
    "en": {
        $vuetify: vuetifyEn,
        message: messageEn,
    },
    "es": {
        $vuetify: vuetifyEs,
        message: messageEs,
    }
}

export const i18n = new VueI18n({
    locale: 'es',
    messages,
    silentTranslationWarn: false
})